import { slugify } from '../../node_modules/@superbet-group/web.lib.utilities/dist/index.esm.js';
import __vue_component__ from '../icons/FlagIcon.vue.js';
import __vue_component__$1 from '../icons/Icon.vue.js';

var TreeItem = {
    functional: true,
    name: 'TreeItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
        depth: {
            type: Number,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: true,
        },
        isCurrentSelection: {
            type: Boolean,
            required: true,
        },
        activeIds: {
            type: Array,
            required: true,
        },
        showItemCount: {
            type: Boolean,
            required: true,
        },
        showToplevelFlag: {
            type: Boolean,
            required: true,
        },
        showSubitemFlag: {
            type: Boolean,
            required: true,
        },
        subitem: {
            type: Boolean,
            required: false,
        },
        components: {
            type: Object,
            default: function () {
                return {
                    FlagIcon: __vue_component__,
                    TreeItem: TreeItem,
                    Icon: __vue_component__$1
                };
            },
        },
    },
    getItemId: function (item) {
        if (typeof item.id === 'number') {
            return item.id;
        }
        if (typeof item.id === 'string') {
            return slugify(item.id);
        }
        return '';
    },
};

export default TreeItem;
